module.exports = __webpack_public_path__ + "20bd03d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/products/creativity.svg
// module id = 765
// module chunks = 2